import { Show, type Component } from "solid-js";
import { PanelLayout } from "@/shared/panel-base";
import { PanelPreview } from "@/shared/panel-primitives";
import { usePanel } from "@/shared/use-panel";
import { useWs } from "@/shared/ws";
import { registerPanel } from "@/panel-registry";

const StoragePanel: Component = () => {
  const ws = useWs();
  const enabled = () => ws.state.agentFeatures?.storage === true;
  const panel = usePanel(() => ({ isFetching: false, error: null }));

  return (
    <PanelLayout title="Stockage / Disques" status={panel.status()}>
      <Show
        when={enabled()}
        fallback={
          <PanelPreview
            feature="storage"
            goal="Voir les disques physiques (SMART, modèle, état), les volumes (espace libre, fragmentation), et l'état BitLocker. Initier des opérations courantes (defrag, chkdsk, optimize) avec confirmation."
            tools={[
              {
                name: "storage_disks_list",
                description: "Disques physiques : modèle, taille, type (SSD/HDD/NVMe), bus, SMART healthstatus",
              },
              {
                name: "storage_volumes_list",
                description: "Volumes : lettre, label, FS, taille totale/libre, fragmentation %, BitLocker on/off",
              },
              {
                name: "storage_volume_details",
                description: "Détail d'un volume : performance counters, IO/s, latence, fragmentation détaillée",
              },
              {
                name: "storage_bitlocker_status",
                description: "État BitLocker par volume + recovery key disponible côté AD/MBAM",
              },
              {
                name: "storage_optimize",
                description: "Defrag / TRIM / Optimize-Volume (destructif soft — requiert userConfirmedAt)",
              },
              {
                name: "storage_chkdsk",
                description:
                  "Lance chkdsk en read-only ou avec /F (destructif — requiert userConfirmedAt + redémarrage)",
              },
            ]}
            notes="Backend agent : CIM direct (plus rapide que les wrappers PowerShell) — MSFT_Disk / MSFT_Volume / MSFT_PhysicalDisk dans root/Microsoft/Windows/Storage ; SMART via Win32_DiskDrive (root/cimv2) ; BitLocker via Win32_EncryptableVolume (root/cimv2/security/MicrosoftVolumeEncryption). Defrag/TRIM/chkdsk restent en exécutables natifs (defrag.exe, chkdsk.exe). Storage Spaces v2 : MSFT_StoragePool."
          />
        }
      >
        <div style={{ padding: "12px" }}>Implémentation en cours…</div>
      </Show>
    </PanelLayout>
  );
};

registerPanel("storage", StoragePanel);
export default StoragePanel;
